import { useContext, useEffect, useState } from 'react'
import { getBalance } from 'api/bank'

// Components
import PageTitle from 'components/title'
import AccountInformation from 'components/AccountInformation'
import PageWrapper from 'components/PageWrapper'
import FallbackError from 'components/FallbackError'
import MovementsListContainer from 'components/movements/MovementsListContainer'

// Constants
import { MovementsContext } from 'contexts/movements'
import { MeContext } from 'contexts/me'
import { trackEvent } from 'analytics/trackFunctions'
import ButtonContainer from './ButtonContainer'

export default function Movements() {
  const [balanceError, setBalanceError] = useState<boolean>(false)

  const { callActivities, setAmountBalance } = useContext(MovementsContext)
  const { me } = useContext(MeContext)

  useEffect(() => {
    trackEvent({ eventName: 'bille_pantalla_movimientos' })
    setBalanceError(false)
    getBalance().then((res) => {
      if (res?.balance) {
        setAmountBalance(res.balance)
      } else {
        setBalanceError(true)
      }
    })
  }, [])

  useEffect(() => {
    if (!me) return
    callActivities({
      walletUUID: me?.bank?.internal_account[0]?.wallet_account
    })
  }, [me])

  return (
    <PageWrapper isSectionHome viewSelected='/movimientos' title='Movimientos'>
      <section className='md:max-w-564 md:flex md:items-end md:flex-col mx-auto mb-16 md:mb-0'>
        <PageTitle titleText='Mi cuenta' />
        {balanceError && <FallbackError type='tu saldo' />}
        {!balanceError && <AccountInformation className='mt-4' />}
        {/* Button Container */}
        <ButtonContainer />

        {/* Movements List container */}
        <div className='mb-28 w-full md:mb-0'>
          <MovementsListContainer />
        </div>
      </section>
    </PageWrapper>
  )
}
